import { createContext } from 'react';

interface ThemeContextData {
  switchTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextData>({
  switchTheme: () => {},
} as ThemeContextData);
